import api from '@/service/api';
import variables from "@/service/variables";
export default class BulletinService {
     
    PostBulletin(flowDetail) {
        return api.post(variables.API_URL +'/api/Bulletin', flowDetail)
    }
    UpdateBulletin(flowDetail) {
        return api.put(variables.API_URL +'/api/Bulletin', flowDetail)
    }
    DeleteBulletin(ID) {
        return api.post(variables.API_URL +'/api/Bulletin/Delete/' + ID)
    }
    GetBulletin(ID) {
        return api.get(variables.API_URL +'/api/Bulletin/' + ID)
    }
    GetBulletins() {
        return api.get(variables.API_URL +'/api/Bulletin');
    }
    GetBulletinBoardTop5() {
        return api.get(variables.API_URL +'/api/Bulletin/GetBulletinBoardTop5');
    }

    

    GetBulletinBoardByContact() {
        return api.get(variables.API_URL +'/api/Bulletin/GetBulletinBoardByContact');
    }
    


    GetBulletinBoardBySystem(system) {
        return api.get(variables.API_URL +'/api/Bulletin/GetBulletinBoardBySystem/'+system);
    }
}
    